import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SelectedEmployeeProvider } from './context/SelectedEmployeeContext';
import ProtectedRoute from './components/ProtectedRoute';

const LoginPage = lazy(() => import('./pages/LoginPage'));
const ProfilePage = lazy(() => import('./pages/ProfilePage'));
const LeavePage = lazy(() => import('./pages/LeavePage'));
const SalaryPage = lazy(() => import('./pages/SalaryPage'));
const SalaryProcessingPage = lazy(() => import('./pages/SalaryProcessingPage'));
const BonusPage = lazy(() => import('./pages/BonusPage'));
const AdminHomePage = lazy(() => import('./pages/AdminHomePage'));

function LoadingFallback() {
  return (
    <div className="loader" style={{ minHeight: '100vh' }}>
      <div className="spinner"></div>
    </div>
  );
}

function AdminRoute({ children }) {
  const { isAdmin } = useAuth();
  if (!isAdmin) {
    return <Navigate to="/profile" replace />;
  }
  return (
    <ProtectedRoute>
      {children}
    </ProtectedRoute>
  );
}

function SuperAdminRoute({ children }) {
  const { isSuperAdmin } = useAuth();
  if (!isSuperAdmin) {
    return <Navigate to="/home" replace />;
  }
  return (
    <ProtectedRoute>
      {children}
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <SelectedEmployeeProvider>
        <Router
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/home"
                element={
                  <AdminRoute>
                    <div className="app-container">
                      <AdminHomePage />
                    </div>
                  </AdminRoute>
                }
              />
              <Route
                path="/salary-processing"
                element={
                  <SuperAdminRoute>
                    <div className="app-container">
                      <SalaryProcessingPage />
                    </div>
                  </SuperAdminRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <div className="app-container">
                      <ProfilePage />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/leaves"
                element={
                  <ProtectedRoute>
                    <div className="app-container">
                      <LeavePage />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/salary"
                element={
                  <ProtectedRoute>
                    <div className="app-container">
                      <SalaryPage />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/bonus"
                element={
                  <ProtectedRoute>
                    <div className="app-container">
                      <BonusPage />
                    </div>
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </Suspense>
        </Router>
      </SelectedEmployeeProvider>
    </AuthProvider>
  );
}
